import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading$ = new Subject<boolean>();
  loadingText$ = new Subject<string>();
  loadingSubText$ = new Subject<string>();

  showCongratulation$ = new Subject<number>();

  constructor() {
    this.isLoading$.next(false);
  }

  setLoading(loading: boolean) {
    this.isLoading$.next(loading);

    if (!loading) {
      this.showCongratulation$.next(0);

      setTimeout(() => {
        this.loadingText$.next('');
        this.loadingSubText$.next('');
      }, 250);
    }
  }

  setText(text: string) {
    this.loadingText$.next(text);
  }

  setSubText(text: string) {
    this.loadingSubText$.next(text);
  }

  showCongratulation(amount: number) {
    this.isLoading$.next(true);
    this.showCongratulation$.next(amount);
  }
}
